import React, { useEffect, useState } from "react";
import config from "../../Config";
import axios from "axios";

function PublicTicketTypeDropDown() {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    axios({
      method: "post",
      url: config.base_url + "Support/GetTicketTypesPublic",
      headers: { "Content-Type": "application/json" },
      data: {},
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setTypes(response.data.ListofTickets || []);
        }
      })
      .catch(() => setTypes([]));
  }, []);

  return types.map((item, index) => (
    <option value={item.TicketType} key={item.ID || index}>
      {item.TicketType}
    </option>
  ));
}

export default PublicTicketTypeDropDown;
